import httpClient from 'utils/httpClient';
import { withPortalScope } from 'utils/portalScope';

const getScopedParams = (params = {}) => withPortalScope(params, { override: true });

export const getSalesOverviewReport = (params = {}) =>
  httpClient.get('/retail-report/sales-overview', { params: getScopedParams(params) });

export const getRevenueByStoreReport = (params = {}) =>
  httpClient.get('/retail-report/revenue-by-store', { params: getScopedParams(params) });

export const getSalesStaffProductivityReport = (params = {}) =>
  httpClient.get('/retail-report/sales-staff-productivity', { params: getScopedParams(params) });

export const getSalesTransactionReport = (params = {}) =>
  httpClient.get('/retail-report/sales-transactions', { params: getScopedParams(params) });

export const getSalesTransactionExportPage = (params = {}) =>
  httpClient.get('/retail-report/sales-transactions/export', { params: getScopedParams(params) });

export const getEmployeeMonthlyIncomeReport = (params = {}) =>
  httpClient.get('/retail-report/employee-monthly-income', { params: getScopedParams(params) });

export const getInventorySalesByStoreReport = (params = {}) =>
  httpClient.get('/retail-report/inventory-sales-by-store', { params: getScopedParams(params) });

export const getInventorySalesByStoreExportPage = (params = {}) =>
  httpClient.get('/retail-report/inventory-sales-by-store/export', { params: getScopedParams(params) });

export const updateEmployeeMonthlyIncome = (username, payload = {}) =>
  httpClient.put(`/retail-report/employee-monthly-income/${encodeURIComponent(username)}`, {
    ...getScopedParams(payload),
  });
